import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import offeringConfigurationSlice from "../../store/offeringConfiguration/offeringConfigurationSlice";
import UserThumbnail from "../../components/userThumbnail/userThumbnail";
import { NetworkAxios, ProgramSetupAxios, UserActivityAxios, OnboardingAxios, ConfigurationAxios, IAMAxios } from "../../API";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Moment from "react-moment";
import notificationSlice from "../../store/notification/notificationSlice";
import authSlice from "../../store/auth/authSlice";
import Profile from "../profile/Profile";
import Avatar from "../commonComponents/Avatar";
import appStateSlice from "../../store/appState/appStateSlice";
import SignalR from "../signalR/signalR";
import ThoughtsCatalog from "../../components/thought/ThoughtsCatalog";

// import config from "../../assets/config/config.json"
import { POINT_TYPE } from "../../shared/Enum";
import CdxToolTip from "../CdxToolTip";
import axios from "axios";

let TopNavigationCancelToken = axios.CancelToken.source();
const Header = (props) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const themeName = useSelector((state) => state.theme.program);
  const links = useSelector(
    (state) => state.offeringConfiguration.topNavigation
  );
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const userTeams = useSelector((state) => state.auth.userTeams);
  //const userPointDetails = useSelector((state) => state.auth.userPoints);

  const offeringUserId = useSelector(
    (state) => state.auth.loggedInUser.offeringUserId
  );
  // const userTokenData = useSelector((state) => state.auth.tokenData);
  // const [isVisible, setVisible] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [teamMembers, setTeamMembers] = useState([]);
  const userTokenData = useSelector((state) => state.auth.tokenData);

  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
  // messagePoint.activityId = indivisualActivityId;

  useEffect(() => {

    var tempToken =JSON.parse(sessionStorage.getItem("cdx-token"));
    if (userTokenData.accessToken) {
      IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
      UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${userTokenData.accessToken}`;
    }else{
      IAMAxios.defaults.headers.common["Authorization"] = `Bearer ${tempToken.accessToken}`;
      ConfigurationAxios.defaults.headers.common["Authorization"] = `Bearer ${tempToken.accessToken}`;
      ProgramSetupAxios.defaults.headers.common["Authorization"] = `Bearer ${tempToken.accessToken}`;
      OnboardingAxios.defaults.headers.common["Authorization"] = `Bearer ${tempToken.accessToken}`;
      NetworkAxios.defaults.headers.common["Authorization"] = `Bearer ${tempToken.accessToken}`;
      UserActivityAxios.defaults.headers.common["Authorization"] = `Bearer ${tempToken.accessToken}`;
    }
  }, []);

  useEffect(() => {
    TopNavigationCancelToken.cancel();
    TopNavigationCancelToken = axios.CancelToken.source();
    // cetworkAxiosCancelToken = cetworkAxiosCancelToken.CancelToken.source();

    ProgramSetupAxios.get("/OfferingConfiguration/topnavigation/" + userDetails.offeringId + "/" + userDetails.missionId + "/" + userDetails.offeringUserId, { cancelToken: TopNavigationCancelToken.token })
      .then(function (response) {
        dispatch(
          offeringConfigurationSlice.actions.setTopNavigation(response.data)
        );
      })
      .catch(function () { });

    NetworkAxios.get('Connection/getmyconnections/' + userDetails.offeringUserId)
      .then(function (response) {
        let data = response.data;
        setTeamMembers(data);
      });

    console.log("userDetails", userDetails);
    if (!userDetails.tourCompleted) {
      props.startTour(true);
    }

  }, [userDetails]);

  useEffect(() => {
    dispatch(authSlice.actions.hideProfile());
    dispatch(
      authSlice.actions.setPoints({
        currentRank: 0,
        teamRank: 0,
        pointsToNextBadge: 0,
        totalPoints: 0,
        experiencePoints: 0,
        bonusPoints: 0,
      })
    );
    GetPoints();
  }, []);

  const GetPoints = () => {
    OnboardingAxios.get('OfferingUsers/getuserpoints/' + userDetails.offeringUserId)
      .then(function (response) {
        let data = response.data;
        dispatch(
          authSlice.actions.setPoints({
            currentLevel: data.currentLevel,
            currentRank: data.currentRank,
            teamRank: data.teamRank,
            pointsToNextBadge: data.pointsToNextBadge,
            totalPoints: data.totalPoints,
            experiencePoints: (data.points.find(x => x.pointsType == POINT_TYPE.experience) ? data.points.find(x => x.pointsType == POINT_TYPE.experience).points : 0) || 0,
            bonusPoints: (data.points.find(x => x.pointsType == POINT_TYPE.bonus) ? data.points.find(x => x.pointsType == POINT_TYPE.bonus).points : 0) || 0,
          })
        );
      });
  };

  const unreadCount = useSelector((state) => state.notifications.unreadCount);
  const notificationList = useSelector(
    (state) => state.notifications.notificationList
  );
  // const [notificationList, setNotificationList] = useState(notifications);

  const [showAll, setShowAll] = useState(false);

  const [showOverlay, setShowOverlay] = useState(false);

  const markAsRead = () => {
    var resArr = notificationList.filter((x) => x.isRead == false);
    var data = resArr.map(function (e) {
      return e.id;
    });
    if (data.length > 0) {

      var requestData = {
        requestModel: data,
        message: messagePoint,
        isBackgroundJob: false
      }
      UserActivityAxios.post("Notification/readnotifications", requestData)
        .then(function (res) {
          dispatch(notificationSlice.actions.clearUnReadCount());
        })
        .catch(function (er) {
          console.log(er);
        });
    }
  };

  const navigationOnClick = (item) => {
    if (item == "") {
      let event = document.getElementById("notificationPopoverBtnId");
      event.click();
    } else {

      var UAdata = {
        email: userDetails.email,
        offeringId: userDetails.offeringId,
        missionId: userDetails.missionId,
        userId: userDetails.userId,
        offeringUserId: userDetails.offeringUserId,
        actionType: "Dashboard",
        actionName: "Help-Dashboard",
        actionOn: "",
      };
      UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

      }).catch(function (error) {
        console.log(error);
      });
      console.log(item);
      return eval(item);
    }

  };

  useEffect(() => {
    // getCoachActivityStats();
    UserActivityAxios.get(
      "Notification/getnotifications/" +
      offeringUserId +
      "/" +
      pageNo +
      "/" +
      pageSize
    )
      .then(function (res) {
        dispatch(notificationSlice.actions.setNotificationList(res.data));
      })
      .catch(function (er) {
        console.log(er);
      });
  }, []);

  const openProfile = (userid, offeringuserid) => {
    dispatch(
      authSlice.actions.setProfileData({
        userId: userid,
        offeringUserId: offeringuserid,
      })
    );
    dispatch(
      authSlice.actions.setProfileStack({
        userId: userid,
        offeringUserId: offeringuserid,
      })
    );
    dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
    dispatch(authSlice.actions.showProfile());
    setTimeout(function () {
      dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
    }, 2000);
  };

  // const profileConfig = useSelector((state) => state.auth.profileConfig);

  // const [coachActivityStats, setCoachActivityStats] = useState(null);
  // const getCoachActivityStats = () => {
  //   NetworkAxios.get("Connection/getcoachactivitystats/" + offeringUserId)
  //     .then(function (res) {
  //       setCoachActivityStats(res.data);
  //     })
  //     .catch(function (er) {
  //       console.log(er);
  //     });
  // };

  const redirectTo = (item) => {
    let obj = JSON.parse(item.actionRoute);
    if (obj.action === "send-connection") {
      history.push("/connections");
    } else if (
      obj.action === "like-comment" ||
      obj.action === "reply-comment"
    ) {
      if (obj.url === "/forum") {
        history.push({
          pathname: obj.url,
          state: obj,
        });
      } else {
        dispatch(appStateSlice.actions.setCurrentStage(obj.stageId));
        dispatch(appStateSlice.actions.setActiveTab("Solve"));
        history.push({
          pathname: obj.url,
          state: obj,
        });
      }
    } else if (
      obj.action === "Like Solution" ||
      obj.action === "Submit Solution" ||
      obj.action === "Comment Solution"
    ) {
      history.push("/viewsolution/" + obj.solutionId + "/" + obj.teamId);
    } else if (obj.action === "gave-coupon") {
      openProfile(userDetails.userId, userDetails.offeringUserId);
    }
    else if (obj.action === "view-activity") {
      setTab("/mission/stage", obj.stageId, "Overview");
    }
    else return;
  };

  const getText = (item) => {
    if (IsJsonString(item)) {
      var temp = JSON.parse(item);
      return temp.actionText;
    } else return "";
  };


  const setTab = (link, stageId, item) => {
    dispatch(appStateSlice.actions.setActiveTab(item));
    dispatch(appStateSlice.actions.setCurrentStage(stageId));
    history.push(link);
  };

  const getFlag = (item) => {


    if (IsJsonString(item)) {
      var temp = JSON.parse(item);
      if (temp.action == "send-connection") {
        if (teamMembers && teamMembers.length > 0) {
          let isConnected = teamMembers.find(x => x.offeringUserId == temp.sender);
          if (isConnected) return false;
          else return true;
        }
        else
          return true;
      }
      else if (temp.actionText === "NA") return false;
      return true;
    } else return false;


  };

  function IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  const getMoreNotification = () => {
    UserActivityAxios.get(
      "Notification/getnotifications/" +
      offeringUserId +
      "/" +
      (pageNo + 1) +
      "/" +
      pageSize
    )
      .then(function (res) {
        setPageNo(pageNo + 1);
        if (res.data.length > 0) {
          dispatch(
            notificationSlice.actions.setNotificationList([
              ...notificationList,
              ...res.data,
            ])
          );
        }
      })
      .catch(function (er) {
        console.log(er);
      });
  };

  const popover = (
    <Popover id="popover-basic" className="profilePopover">
      <div className="popover-profile-top-section">
        {/* <div className="profile-picture">
          <div className="profile-avatar">
          <UserThumbnail currentUser={true} className="profile-avatar" />
          </div>
        </div> */}
        <Avatar {...userDetails} className="small" />
        <div className="profile-details">
          <div className="profile-name">
            {userDetails.firstName + " " + userDetails.lastName}
          </div>
          <div className="profile-teamname">{userDetails.teamName}</div>
          <div className="profile-missionname">{userDetails.missionName}</div>
        </div>
      </div>
      <div className="popover-profile-bottom-section">
        <div className="profile-email">{userDetails.email}</div>
        <div
          className="profile-view"
          onClick={() => {
            openProfile(userDetails.userId, userDetails.offeringUserId);
          }}
        >
          View Profile
        </div>
      </div>
    </Popover>
  );

  const NotificationItem = ({ item }) => {
    return (
      <div className="notification-item">
        <div className="notification-avatar">
          {item.isSystem && (
            <UserThumbnail isSystem={true} data={item.userProfile} />
          )}

          {!item.isSystem && (
            <Avatar {...item.userProfile} className="small" />
          )}
          {!item.isRead && (
            <div className="notification-read-indicator"></div>
          )}
        </div>
        <div className="notification-item-content">
          <div className="notification-info">
            {!item.isSystem && (
              <>
                {item.userProfile.firstName}{" "}
                {item.userProfile.lastName}{" "}
                <span className="notificationText">
                  {item.notificationText}
                </span>
              </>
            )}
            {item.isSystem && (
              <>
                System{" "}
                <span className="notificationText">
                  {item.notificationText}
                </span>
              </>
            )}
            <div className="notification-time">
              <Moment
                format="MM/DD hh:mm A"
                local={true}
                date={new Date(item.notificationDate + "Z")}
              />
            </div>
          </div>

          {getFlag(item.actionRoute) && (
            <button
              className="ms-2"
              onClick={() => {
                redirectTo(item);
                setShowOverlay(false);
                setShowAll(false);
              }}
            >
              {getText(item.actionRoute)}
            </button>
          )}

        </div>
      </div>
    );
  };

  const handleTeamChange = (e) => {
    if(e.target.value == userDetails.teamId)  return;
    
    let selectedValue = userTeams.find(x=>x.id== e.target.value);
    console.log("in team change ");
    history.push({
      pathname: "/login",
      state: { offeringId: selectedValue.offeringId, teamId: selectedValue.id, email: userDetails.email },
    });
  }

  return (
    <>
      <Profile></Profile>
      <SignalR></SignalR>
      {showOverlay && <div className="overlay"></div>}
      <div className="header">
        <div className="branding">
          <Link to="/home">
            <div className="logo-image"> </div>
          </Link>
          <div className="logo-text"></div>
          <div className="branding-glow"></div>
        </div>
        <div className="right-section">
          {userDetails.roleId === 5 ? (
            <div className="profile-section">
              <div className="profile-details">
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  overlay={popover}
                  rootClose
                >
                  <span className="name">
                    {userDetails.firstName + " " + userDetails.lastName}
                  </span>
                </OverlayTrigger>
                <span className="badge-info-text">
                  {userDetails.missionName}
                </span>
                <div className="">
                  <select className="team-dropdown" onChange={(e) => {
                  handleTeamChange(e);
                }}>
                    {userTeams && userTeams.map((item, index) => {
                      return (
                        <option
                          key={item.id + index}
                          value={item.id}
                          selected={item.id === userDetails.teamId}
                        >{item.teamName}</option>
                      );
                    })}
                  </select>
                </div>

              </div>
              <div className="profile-picture">
                {/* <div className="profile-avatar"> */}
                <Avatar {...userDetails} frame="coach" className="small" />
                {/* </div> */}
              </div>

              <div className="vertical-devider"></div>
              {/* {coachActivityStats && (
                <div className="points">
                  <div className="point-item total">
                    My Connections{" "}
                    <div className="point">
                      {coachActivityStats.totalConnections}
                    </div>
                  </div>
                  <div className="point-item">
                    My Posts{" "}
                    <div className="point">{coachActivityStats.totalPosts}</div>
                  </div>
                  <div className="point-item">
                    My Posts in the Feed{" "}
                    <div className="point">{coachActivityStats.totalFeeds}</div>
                  </div>
                </div>
              )} */}
            </div>
          ) : (
            <div className="profile-section">
              {/* <div className="rank-details">
                <div className="corner-border">
                  <div className="rank">
                    Your Rank
                    <div className="rank-count">{userDetails.currentRank}</div>
                  </div>
                </div>
                <div className="corner-border">
                  <div className="rank">
                    Team Rank
                    <div className="rank-count">{userDetails.teamRank}</div>
                  </div>
                </div>
              </div> */}
              <div className="profile-details">
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  overlay={popover}
                  rootClose
                >
                  <span className="name">
                    {userDetails.firstName + " " + userDetails.lastName}
                  </span>
                </OverlayTrigger>
                {/* <span className="badge-info-text">Points till next badge</span> */}
                {/* <span className="point-count">
                  {parseInt(userDetails.pointsToNextBadge) < 0 ? 0 : userDetails.pointsToNextBadge}
                </span> */}
              </div>
              <div className="profile-picture">
                {/* <UserThumbnail currentUser={true} className="profile-avatar" /> */}
                <Avatar {...userDetails} frame="coach" className="small" />
              </div>

              <div className="vertical-devider"></div>
              {/* <div className="points">
                <div className="point-item total">
                  Points <div className="point">{userDetails.totalPoints}</div>
                </div>
                <div className="point-item">
                  Experience Points{" "}
                  <div className="point">{userDetails.experiencePoints}</div>
                </div>
                <div className="point-item">
                  Bonus Points{" "}
                  <div className="point">{userDetails.bonusPoints}</div>
                </div>
              </div> */}
            </div>
          )}

          <div className="justify-content-end headerIconDiv">
            {/* {userDetails.roleId !== 5 && <ThoughtsCatalog />} */}
            {links.map((item) => {
              let imgSrc = "/" + themeName + `/img/` + item.name + ".svg";

              return (

                <div
                  key={item.name}
                  className={
                    `nav-item-icon ${item.name == "Notification" &&
                      item.name == "Notifications"
                      ? "notificationPopoverBtn "
                      : ""
                    }` + item.name
                  }
                  onClick={() => navigationOnClick(item.action)}
                >
                  {item.name != "Notification" &&
                    item.name != "Notifications" && (
                      <CdxToolTip trigger={['hover', 'focus']} content={item.name}>
                        <img src={imgSrc.toLowerCase()} alt={item.name} />
                      </CdxToolTip>
                    )}

                  {(item.name == "Notification" ||
                    item.name == "Notifications") &&
                    unreadCount != 0 && (
                      <div
                        id="notificationIcon"
                        className="indicator notificationPopoverBtn notificationIcon"
                      >
                        {unreadCount}
                      </div>
                    )}
                  {(item.name == "Notification" ||
                    item.name == "Notifications") &&
                    notificationList && (
                      <OverlayTrigger
                        trigger="click"
                        key="bottom"
                        placement="bottom"
                        target="notificationIcon"
                        onExited={() => {
                          setShowOverlay(false);
                          setShowAll(false);
                          markAsRead();
                        }}
                        overlay={
                          <Popover
                            className="notificationPopover"
                            id={`popover-positioned-bottom`}
                          >
                            {notificationList.length == 0 && (
                              <div className="notificationWrapper noNotifications">
                                No notifications
                              </div>
                            )}
                            {notificationList.length > 0 && (
                              <div className="notificationPopoverInnerDiv">
                                {notificationList
                                  .slice(
                                    0,
                                    showAll ? notificationList.length : 5
                                  )
                                  .map((item, index) => {
                                    return (
                                      <div
                                        className="notificationWrapper"
                                        key={index}
                                      >
                                        <NotificationItem item={item} />

                                      </div>
                                    );
                                  })}
                                {notificationList.length > 5 && !showAll && (
                                  <div
                                    className="notificationViewAll"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowAll(true);
                                    }}
                                  >
                                    <span>View All</span>
                                  </div>
                                )}
                              </div>
                            )}
                          </Popover>
                        }
                        rootClose
                      >
                        <div id="notificationPopoverBtnId"

                          onClick={() => {
                            setShowOverlay(!showOverlay);
                          }}>
                          <CdxToolTip trigger={['hover', 'focus']} content={item.name} >
                            <img
                              className="notificationPopoverBtn"
                              src={imgSrc.toLowerCase()}
                              alt={item.name}
                            />
                          </CdxToolTip>
                        </div>
                      </OverlayTrigger>
                    )
                  }
                </div>

              );
            })}
          </div>

          {/*  */}
        </div>
      </div>

      {/* <Profile
                isVisible={isVisible}
                setVisible={(value) => { setVisible(value) }}
            /> */}
    </>
  );
};

export default Header;
